// extracted by mini-css-extract-plugin
export default {"headerDiv":"Header_headerDiv__9R3Go","logoContainer":"Header_logoContainer__Ca1SE"};